import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Layout from '../components/Layout'
import { publicRoute } from './allRoutes'
import ScrollToTop from '../components/ScrollToTop.jsx'

const AppRoutes = () => {
    return (
        <>
         <ScrollToTop />
        <Routes>
            <Route path="/" element={<Layout />}>
                {publicRoute.map(({ id, path, element }) => (
                    <Route key={id} path={path} element={element} />
                ))}
            </Route>
        </Routes>
        </>
    )
}

export default AppRoutes
